import { useQuery } from "@tanstack/react-query";

import { refreshToken } from "../services";
import { updateUserToken } from "../services/cookies";

export function useRefreshToken() {
  return useQuery({
    queryKey: ["refresh-token"],
    queryFn: async () => {
      const result = await refreshToken();

      updateUserToken(result.token, result.refreshToken);

      return result;
    },
  });
}
